/* eslint-disable max-len */
import * as questionIds from "../../consultationQuestions/questionIds";

export const confidentialityDeclarationQuestions = [
    {
        id: questionIds.InformedOfMedicals,
        questionText: "I have informed the employee of the nature and purpose of medicals that are to be undertaken and they have agreed to undertake the appropriate medicals",
    },
    {
        id: questionIds.PrivacyStatementConfirmation,
        questionText: "I can confirm that I have provided the employee with access to the Optima Health Privacy Statement or details about where it can be found which clearly explains in detail how, where, how and when personal and health data will be processed",
    },
    {
        id: questionIds.InformationHeldSecurelyConfirmation,
        questionText: "I understand that my information will be held securely and if I wish to gain access to my medical information I can do so by requesting access in writing to Optima Health",
    },
    {
        id: questionIds.PhotographicIdSeen,
        questionText: "Photographic ID seen to confirm identify prior to medical taking place",
    },
];
/* eslint-enable max-len */
